<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <string-form-field
      :label="$t('request.fields.customer')"
      required
      disabled
      :value="value.customer.companyName"
    />

    <string-form-field
      :label="$t('request.fields.status')"
      required
      disabled
      :value="$t('requestStatus.' + value.status)"
    />

    <string-form-field
      :label="$t('request.fields.network')"
      required
      disabled
      :value="value.network.companyName"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
